import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { DashboardComponent } from './dashboard/dashboard.component';
import { AuthGuard } from '@guards/auth.guard';

const routes: Routes = [
  {
    path: "",
    component: DashboardComponent,
    canActivate: [AuthGuard]
  },
  {
    path: "blog",
    loadChildren: () => import('./blog/blog.module').then(m => m.BlogModule),
    canActivate: [AuthGuard]
  },
  {
    path: "user",
    loadChildren: () => import('./users/users.module').then(m => m.UsersModule),
    canActivate: [AuthGuard]
  },
  {
    path: "house",
    loadChildren: () => import('./house/house.module').then(m => m.HouseModule),
    canActivate: [AuthGuard]
  },
  {
    path: "page",
    loadChildren: () => import('./page/page.module').then(m => m.PageModule),
    canActivate: [AuthGuard]
  },
  {
    path: "portfoilo",
    loadChildren: () => import('./portfolio/portfolio.module').then(m => m.PortfolioModule),
    canActivate: [AuthGuard]
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class DashboardPagesRoutingModule { }
